import type { InjectionKey, Ref } from "vue";

export const DS_DIALOG_REF_PROVIDE_KEY: InjectionKey<Ref<HTMLDialogElement | null>> = Symbol("ds-dialog-ref");
